<template>
  <Header/>
  <section class="myAccount">
    <div class="containerMyAccount">
      <div class="sidebar">
        <div class="sidebar-header">
          <div class="user-info">
            <div class="user-avatar">
              <img :src="userPortalWeflix?.user?.avatar || require('@/assets/user.png')" alt="Avatar">
            </div>
            <div class="user-name">
              {{userPortalWeflix?.user?.name}}
            </div>
          </div>
        </div>
        <div class="sidebar-menu">
          <div class="menu-item" :class="{ active: isActiveTab(1) }" @click="setActiveTab(1)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 17px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/></svg>
            <span class="menu-label">Minha Conta</span>
          </div>
          <div class="menu-item" :class="{ active: isActiveTab(2) }" @click="setActiveTab(2)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 304c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM400 144l64 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-64 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-64 0c-22.1 0-40 17.9-40 40z"/></svg>

            <span class="menu-label">Pagamento</span>
          </div>
          <div class="menu-item" :class="{ active: isActiveTab(3) }" @click="setActiveTab(3)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M128 128l0 64 192 0 0-64c0-53-43-96-96-96s-96 43-96 96zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 16 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 272c0-44.2 35.8-80 80-80l16 0zM32 272l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L80 224c-26.5 0-48 21.5-48 48z"/></svg>            <span class="menu-label">Alterar Senha</span>
          </div>
        </div>
      </div>

      <div class="content-area">
        <section class="content-section" :class="[isActiveTab(1)? 'active': '']">
          <User />
        </section>

        <section class="content-section" :class="[isActiveTab(2)? 'active': '']">
          <Payment />
        </section>

        <section class="content-section" :class="[isActiveTab(3)? 'active': '']">
          <Password />
        </section>
      </div>
    </div>
  </section>
  <Footer/>
</template>

<script>
import Header from "@/components/Weflix/Hedaer.vue"
import Footer from '@/components/Weflix/Footer.vue'
import { mapState, mapActions } from 'vuex';
import User from '@/components/Weflix/User/Account.vue'
import Password from '@/components/Weflix/User/Password.vue'
import Payment from '@/components/Weflix/User/Payment.vue'

export default {
  data() {
    return {
      activeTab: 1,
    }
  },
  computed: {
    ...mapState(['finalWebsite', 'userPortalWeflix']),
  },
  created() {
  },
  components: {
    Header,
    Footer,
    User,
    Password,
    Payment
  },
  methods: {
    ...mapActions(['storeUserPortalWeflix']),
    setActiveTab(tabNumber) {
      this.activeTab = tabNumber;
    },
    isActiveTab(tabNumber) {
      return this.activeTab === tabNumber;
    }
  }
}
</script>

<style scoped>
.myAccount {
  display: flex;
  min-height: calc(100vh - 140px);
  background-color: #141414;
  padding: 70px 20px 0;
}

.containerMyAccount {
  display: flex;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  gap: 30px;
}

.sidebar {
  min-width: 280px;
  background: #1f1f1f;
  padding: 20px 0;
  color: #fff;
  border-radius: 8px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.sidebar-header {
  padding: 0 20px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-name {
  font-size: 1.2em;
  font-weight: 600;
  color: #fff;
  text-transform: capitalize;
}

.sidebar-menu {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.menu-item {
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: rgba(255,255,255,0.7);
  position: relative;
}

.menu-item:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
}

.menu-item.active {
  background: rgba(255,255,255,0.1);
  color: #fff;
  border-left: 3px solid #e50914;
}

.menu-item fa {
  width: 20px;
  font-size: 1.1em;
}

.menu-label {
  display: inline;
}

.content-area {
    background: #1f1f1f;
    border-radius: 8px;
    padding: 15px;
    width: 100%;
    margin-bottom: 30px;
}

.content-section {
  display: none;
  animation: fadeIn 0.3s ease;
}

.content-section.active {
  display: block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* MOBILE LAYOUT MELHORADO */
@media (max-width: 768px) {
  .myAccount {
    padding: 70px 0 0;
  }

  .containerMyAccount {
    flex-direction: row;
    gap: 0;
    width: 100%;
    max-width: 100vw;
    min-width: 0;
    background-color: black;
    gap: 0px;
  }

  .sidebar {
    min-width: 60px;
    max-width: 60px;
    width: 60px;
    padding: 0;
    border-radius: 0 8px 8px 0;
    height: auto;
    background: #1f1f1f;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 70px;
    z-index: 2;
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  }

  .sidebar-header {
    padding: 20px 0 10px 0;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .user-info {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .user-name {
    display: none;
  }

  .sidebar-menu {
    padding: 0;
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
  }

  .menu-item {
    padding: 18px 0;
    justify-content: center;
    gap: 0;
    width: 100%;
    border-left: none;
    border-radius: 0;
    background: none;
    position: relative;
    transition: background 0.2s;
  }

  .menu-item.active {
    color: #e50914;
    border-left: none;
  }

  .menu-item:hover {
    background: rgba(255,255,255,0.08);
    color: #fff;
  }

  .menu-item fa {
    font-size: 1.5em;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .menu-label {
    display: none;
  }

  .content-area {
    padding: 20px 10px;
    margin-bottom: 0;
    border-radius: 0;
    width: 100%;
    min-width: 0;
    max-width: 100vw;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>